// The single source of truth for "how many picks make a list complete".
// A recommender's list is public only once it's full: the recommenders
// grid, the restaurant detail pages, the sitemap, and the aggregated_picks
// view (see supabase/migrations/004_full_top_five_gate.sql) all gate on
// this. The api/ functions are CommonJS and can't import from /src, so
// they hardcode 5 with a pointer back to this file.
export const FULL_LIST_SIZE = 5;

export function isFullList(pickCount: number): boolean {
  return pickCount >= FULL_LIST_SIZE;
}
